import { Button, Space } from "antd";
import { useEffect, useState } from "react";
import { useUser } from "../../contexts/UserContext";
import FormHeader from "./FormHeader";
import FormInput from "../elements/FormInput";
import { useTranslation } from "react-i18next";
import {EDEX_RENEW_URL, GetClientType} from "../../config";
import { useDispatch, useSelector } from "react-redux";
import { getActiveLicense } from "../../redux/ActiveLicense/action";
import { getProfile } from "../../redux/Profile/action";
import { useBrowser } from "../../contexts/BrowserContext";
import { Initialize} from "../../hooks/initialize";
const LoginForm = ({ setLicenseModalOpen }) => {


    const licenceData = useSelector((state) => state.activeLicense.activeLicenseData)

    const { userLoading, loginUser } = useUser();
    const [inputValue, setInputValue] = useState('');
    const [confirm, setConfirm] = useState(false)
    const { t } = useTranslation();
    const { setIsLoginModalOpen } = useUser();
    const {browser} = useBrowser()

    const dispatch = useDispatch();


    const onLogin = async () => {
        const sysInfo = await browser.getSysInfo()
        const machineId = await browser.getMachinId()
        const data = {
            license: inputValue,
            sysinfo: sysInfo,
            machineId: machineId,
            client: GetClientType()
        }
        dispatch(getActiveLicense(data))
        setConfirm(true)
        Initialize()

    }


    useEffect(() => {

        if (Number(licenceData) >= 200 && Number(licenceData) < 300) {
            dispatch(getProfile())
            setLicenseModalOpen(false);
        }

    }, [licenceData])




    return (
        <div>
            <div>
                <FormHeader title="Login" icon={<span className="svg-icon icon-user" style={{ fontSize: 28 }}></span>}>
                    <span style={{ width: "100%" }}>{t('user.enter_license_code')}</span>
                </FormHeader>
                <div>
                    <FormInput label={t('user.license_code')} value={inputValue}
                        onChange={(event) => {
                            setInputValue(event.target.value);
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter')
                                onLogin();
                        }}
                    />

                    <div style={{ display: "flex" }}>
                        <Space>
                            <Button type="primary" className="active-btn" onClick={onLogin}>{t('user.active')}</Button>
                            <Button className="buy-btn" href={EDEX_RENEW_URL} target="_blank">{t('user.buy')}</Button>
                        </Space>
                    </div>

                </div>
            </div>

        </div>)
};


export default LoginForm;
